import { FieldSkeleton } from '@/components/layout/field-row'
import { Typography } from '@/components/ui/typography'

import * as S from './side-nav.styled'
import { SideNavHeaderProps } from './side-nav.types'

export const SideNavHeader = ({
  avatarSrc,
  badges,
  hideAvatar,
  subtitle,
  title,
}: SideNavHeaderProps) => (
  <S.HeaderCard>
    <S.HeaderRow>
      {!hideAvatar && <S.HeaderAvatar zoomable alt={title} shape="square" src={avatarSrc} />}
      <S.HeaderInfo>
        <Typography as="div" color="black800" size="heading-tiny" wordBreak="break-word">
          {title}
        </Typography>
        {subtitle && (
          <Typography as="div" color="black400" size="text-medium" weight="medium">
            {subtitle}
          </Typography>
        )}
      </S.HeaderInfo>
    </S.HeaderRow>
    {badges && <S.BadgesRow>{badges}</S.BadgesRow>}
  </S.HeaderCard>
)

// Note: only the record's values are skeletons, sized like the loaded avatar (6.4rem), title and
// subtitle (2rem line-height) and small badge (2.4rem)
export const SideNavHeaderSkeleton = () => (
  <S.HeaderCard aria-hidden>
    <S.HeaderRow>
      <S.HeaderAvatarSkeleton height="6.4rem" width="6.4rem" />
      <S.HeaderInfo>
        <FieldSkeleton height="2rem" width="14rem" />
        <FieldSkeleton height="2rem" width="8rem" />
      </S.HeaderInfo>
    </S.HeaderRow>
    <S.BadgesRow>
      <FieldSkeleton height="2.4rem" width="8rem" />
    </S.BadgesRow>
  </S.HeaderCard>
)
